export default {
  lang: 'ro',
  dir: 'ltr',
  common: {
    ok: 'Ok',
    cancel: 'Anulaţi',
    key_backspace: 'backspace',
    key_del: 'ştergere',
    key_down: 'jos',
    key_up: 'sus',
    more_opts: 'Mai multe opţiuni',
    url: 'URL',
    width: 'Lăţime',
    height: 'Înălţime'
  },
  misc: {
    powered_by: 'Powered by'
  },
  ui: {
    toggle_stroke_tools: 'Arătaţi/ascundeţi mai multe unelte de contur',
    palette_info: 'Faceţi clic pentru a schimba culoarea de umplere, Shift-clic pentru a schimba culoarea de contur',
    zoom_level: 'Schimbarea nivelului de zoom',
    panel_action: 'Click to open side panel',
    quality: 'Quality:',
    pathNodeTooltip: 'Drag node to move it. Double-click node to change segment type',
    pathCtrlPtTooltip: 'Drag control point to adjust curve properties',
    pick_stroke_paint_opacity: 'Pick a Stroke Paint and Opacity',
    pick_fill_paint_opacity: 'Pick a Fill Paint and Opacity',
    group_identify_label: 'Group identification label',
    export_type_label: 'Select an image type for export:'
  },
  properties: {
    id: 'Identificare element',
    fill_color: 'Schimbarea culorii de umplere',
    stroke_color: 'Schimbarea culorii de contur',
    stroke_style: 'Schimbarea stilului de contur',
    stroke_width: 'Schimbarea lăţimii conturului',
    pos_x: 'Schimbă coordonata X',
    pos_y: 'Schimbă coordonata Y',
    linecap_butt: 'Capăt de linie: Butuc',
    linecap_round: 'Capăt de linie: Rotund',
    linecap_square: 'Capăt de linie: Pătrat',
    linejoin_bevel: 'Articulaţia liniei: Teşită',
    linejoin_miter: 'Articulaţia liniei: Unghi ascuţit',
    linejoin_round: 'Articulaţia liniei: Rotundă',
    angle: 'Schimbarea unghiul de rotaţie',
    blur: 'Schimbarea valorii estomparii gaussiene',
    opacity: 'Schimbarea gradului de opacitate',
    circle_cx: 'Schimbarea coordonatei CX a cercului',
    circle_cy: 'Schimbarea coordonatei CY a cercului',
    circle_r: 'Schimbarea razei cercului',
    ellipse_cx: 'Schimbarea coordonatei CX a elipsei',
    ellipse_cy: 'Schimbarea coordonatei CY a elipsei',
    ellipse_rx: 'Schimbarea razei elipsei X',
    ellipse_ry: 'Schimbarea razei elipsei Y',
    line_x1: 'Schimbarea coordonatei x a punctului de start',
    line_x2: 'Schimbarea coordonatei x a punctului final',
    line_y1: 'Schimbarea coordonatei y a punctului de start',
    line_y2: 'Schimbare coordonatei y a punctului final',
    rect_height: 'Schimbarea înălţimii dreptunghiului',
    rect_width: 'Schimbarea lăţimii dreptunghiului',
    corner_radius: 'Schimbarea razei colţului dreptunghiului',
    image_width: 'Schimbarea lăţimii imaginii',
    image_height: 'Schimbarea înălţimii imaginii',
    image_url: 'Schimbaţi URL-ul',
    node_x: 'Schimbă coordonata x a punctului',
    node_y: 'Schimbă coordonata x a punctului',
    seg_type: 'Schimbă tipul de segment',
    straight_segments: 'Drept',
    curve_segments: 'Curb',
    text_contents: 'Schimbarea conţinutului textului',
    font_family_label: 'Font:',
    font_family: 'Modificare familie de fonturi',
    font_size: 'Schimbă dimensiunea fontului',
    bold: 'Text Îngroşat',
    text_decoration_underline: 'Underline',
    text_decoration_linethrough: 'Line-Through',
    text_decoration_overline: 'Overline',
    italic: 'Text Înclinat',
    text_anchor_start: 'Align the text in start',
    text_anchor_middle: 'Align the text in middle',
    text_anchor_end: 'Align the text in end',
    text_letter_spacing: 'Change the letter spacing',
    text_word_spacing: 'Change the word spacing',
    text_length: 'Lets you specify the width of the space into which the text will draw',
    text_length_adjust: 'Length adjust',
    text_length_adjust_spacing: 'Spacing',
    text_length_adjust_spacing_and_glyphs: 'Spacing & Glyphs',
    class: 'Element class',
    serif: 'Serif',
    sans_serif: 'Sans-serif',
    cursive: 'Cursive',
    fantasy: 'Fantasy',
    monospace: 'Monospace',
    courier: 'Courier',
    helvetica: 'Helvetica',
    times: 'times',
    prefs_and_content: 'Store preferences and SVG content locally',
    prefs_only: 'Only store preferences locally',
    no_prefs_or_content: 'Do not store my preferences or SVG content locally',
    jgraduate_pad: 'Pad',
    jgraduate_reflect: 'Reflect',
    jgraduate_repeat: 'Repeat'
  },
  tools: {
    main_menu: 'Menu Principal',
    bkgnd_color_opac: 'Schimbare culoare de fundal / opacitate',
    connector_no_arrow: 'Fără săgeată',
    fitToContent: 'Dimensionare la conţinut',
    fit_to_all: 'Potrivire la tot conţinutul',
    fit_to_canvas: 'Potrivire la Şevalet',
    fit_to_layer_content: 'Potrivire la conţinutul stratului',
    fit_to_sel: 'Potrivire la selecţie',
    align_relative_to: 'Aliniere în raport cu ...',
    relativeTo: 'în raport cu:',
    page: 'pagină',
    largest_object: 'cel mai mare obiect',
    selected_objects: 'obiectele alese',
    smallest_object: 'cel mai mic obiect',
    new_doc: 'Imagine nouă',
    open_doc: 'Imagine deschisă',
    export_img: 'Export',
    save_doc: 'Salvare imagine',
    import_doc: 'Importare SVG',
    align_to_page: 'Aliniere la pagină',
    align_bottom: 'Aliniere jos',
    align_center: 'Aliniere la centru',
    align_left: 'Aliniere la stânga',
    align_middle: 'Aliniere la mijloc',
    align_right: 'Aliniere la dreapta',
    align_top: 'Aliniere sus',
    mode_select: 'Unealtă de Selectare',
    mode_fhpath: 'Unealtă de Traiectorie',
    mode_line: 'Unealtă de Linie',
    mode_rect: 'Unealtă de Dreptunghi',
    mode_square: 'Unealtă de Pătrat',
    mode_fhrect: 'Dreptunghi cu mana liberă',
    mode_ellipse: 'Elipsă',
    mode_circle: 'Cerc',
    mode_fhellipse: 'Elipsă cu mana liberă',
    mode_path: 'Unealtă de Traiectorie',
    mode_text: 'Unealtă de Text',
    mode_image: 'Unealtă de Imagine',
    mode_zoom: 'Unealtă de Zoom',
    no_embed: 'NOTE: Aceasta imagine nu poate fi inglobată. Va depinde de aceasta traiectorie pentru a fi prezentată.',
    undo: 'Anulare',
    redo: 'Refacere',
    tool_source: 'Editare Cod Sursă',
    wireframe_mode: 'Mod Schelet',
    clone: 'Clonează Elementul/ele',
    del: 'Şterge Elementul/ele',
    group_elements: 'Grupare Elemente',
    make_link: 'Crează (hyper)link',
    set_link_url: 'Setează link URL (lăsaţi liber pentru eliminare)',
    to_path: 'Converteşte in Traiectorie',
    reorient_path: 'Reorientează Traiectoria',
    ungroup: 'Anulare Grupare Elemente',
    docprops: 'Proprietăţile Documentului',
    editor_homepage: 'SVG-Edit Home Page',
    move_bottom: 'Mutare în jos',
    move_top: 'Mutare în sus',
    node_clone: 'Clonează Punct',
    node_delete: 'Şterge Punct',
    node_link: 'Uneşte Punctele de Control',
    add_subpath: 'Adăugaţi sub-traiectorie',
    openclose_path: 'Deschide/inchide sub-traiectorie',
    source_save: 'Folosiţi Schimbările',
    cut: 'Tăiere',
    copy: 'Copiere',
    paste: 'Reproducere',
    paste_in_place: 'Reproducere pe loc',
    delete: 'Ştergere',
    group: 'Group',
    move_front: 'Pune in faţa',
    move_up: 'Pune in spate',
    move_down: 'Trimite in faţa',
    move_back: 'Trimite in spate',
    tool_unlink_use: 'Break link to reference element (make unique)',
    ellipse_circle_tool: 'Ellipse/Circle Tool',
    square_rect_tool: 'Square/Rect Tool',
    remember_this_choice: 'Remember this choice?',
    remember_this_choice_title: 'If you choose to opt out of storage while remembering this choice, the URL will change so as to avoid asking again.'
  },
  layers: {
    layer: 'Strat',
    layers: 'Straturi',
    del: 'Ştergeţi Strat',
    move_down: 'Mutare Strat în Jos',
    new: 'Strat Nou',
    rename: 'Redenumiţi Stratul',
    move_up: 'Mutare Strat în Sus',
    dupe: 'Duplicaţi Stratul',
    merge_down: 'Fuzionare in jos',
    merge_all: 'Fuzionarea tuturor',
    move_elems_to: 'Mută elemente la:',
    move_selected: 'Mută elementele selectate pe un alt strat'
  },
  config: {
    image_props: 'Proprietăţile Imaginii',
    doc_title: 'Titlul',
    doc_dims: 'Dimensiunile Şevaletului',
    included_images: 'Imaginile Incluse',
    image_opt_embed: 'Includeţi Datele (fişiere locale)',
    image_opt_ref: 'Foloseşte referinţe la fişiere',
    editor_prefs: 'Preferinţele Editorului',
    language: 'Limba',
    background: 'Fondul Editorului',
    editor_img_url: 'URL-ul Imaginii',
    editor_bg_note: 'Notă: Fondul nu va fi salvat cu imaginea.',
    select_predefined: 'Selecţii predefinite:',
    units_and_rulers: 'Unitati si Rigle',
    show_rulers: 'Arată Riglele',
    base_unit: 'Unitate de baza:',
    grid: 'Caroiaj',
    snapping_onoff: 'Fixare on/off',
    snapping_stepsize: 'Dimensiunea pasului de fixare:',
    grid_color: 'Grid color',
    done: 'Done',
    change_xxx_color: 'Change xxx color',
    pick_paint_opavity: 'Pick a {{newValue}} Paint and Opacity',
    open_color_picker: 'Click To Open Color Picker',
    jpicker_title: 'Drag Markers To Pick A Color',
    jpicker_new_color: 'new',
    jpicker_current_color: 'current',
    jpicker_tooltip_colors_new_color: 'New Color - Press &ldquo;OK&rdquo; To Commit',
    jpicker_tooltip_colors_current_color: 'Click To Revert To Original Color',
    jpicker_tooltip_buttons_ok: 'Commit To This Color Selection',
    jpicker_tooltip_buttons_cancel: 'Cancel And Revert To Original Color',
    jpicker_tooltip_hue_radio: 'Set To &ldquo;Hue&rdquo; Color Mode',
    jpicker_tooltip_hue_textbox: 'Enter A &ldquo;Hue&rdquo; Value (0-360&deg;)',
    jpicker_tooltip_saturation_radio: 'Set To &ldquo;Saturation&rdquo; Color Mode',
    jpicker_tooltip_saturation_textbox: 'Enter A &ldquo;Saturation&rdquo; Value (0-100%)',
    jpicker_tooltip_value_radio: 'Set To &ldquo;Value&rdquo; Color Mode',
    jpicker_tooltip_value_textbox: 'Enter A &ldquo;Value&rdquo; Value (0-100%)',
    jpicker_tooltip_red_radio: 'Set To &ldquo;Red&rdquo; Color Mode',
    jpicker_tooltip_red_textbox: 'Enter A &ldquo;Red&rdquo; Value (0-255)',
    jpicker_tooltip_green_radio: 'Set To &ldquo;Green&rdquo; Color Mode',
    jpicker_tooltip_green_textbox: 'Enter A &ldquo;Green&rdquo; Value (0-255)',
    jpicker_tooltip_blue_radio: 'Set To &ldquo;Blue&rdquo; Color Mode',
    jpicker_tooltip_blue_textbox: 'Enter A &ldquo;Blue&rdquo; Value (0-255)',
    jpicker_tooltip_alpha_radio: 'Set To &ldquo;Alpha&rdquo; Color Mode',
    jpicker_tooltip_alpha_textbox: 'Enter A &ldquo;Alpha&rdquo; Value (0-100)',
    jpicker_tooltip_hex_textbox: 'Enter A &ldquo;Hex&rdquo; Color Value (#000000-#ffffff)',
    jpicker_tooltip_hex_alpha: 'Enter A &ldquo;Alpha&rdquo; Value (#00-#ff)',
    jgraduate_solid_color: 'Solid Color',
    jgraduate_linear_gradient: 'Linear Gradient',
    jgraduate_radial_gradient: 'Radial Gradient',
    jgraduate_begin_point: 'Begin Point',
    jgraduate_enter_starting_x: 'Enter starting x value between 0.0 and 1.0',
    jgraduate_enter_starting_y: 'Enter starting y value between 0.0 and 1.0',
    jgraduate_end_point: 'End Point',
    jgraduate_enter_ending_x: 'Enter ending x value between 0.0 and 1.0',
    jgraduate_enter_ending_y: 'Enter ending y value between 0.0 and 1.0',
    jgraduate_center_point: 'Center Point',
    jgraduate_enter_value_x: 'Enter x value between 0.0 and 1.0',
    jgraduate_enter_value_y: 'Enter y value between 0.0 and 1.0',
    jgraduate_focal_point: 'Focal Point',
    jgraduate_match_center: 'Match center:',
    jgraduate_enter_focal_x: 'Enter x value between 0.0 and 1.0',
    jgraduate_enter_focal_y: 'Enter y value between 0.0 and 1.0',
    jgraduate_spread_method: 'Spread method',
    jgraduate_radius: 'Radius:',
    jgraduate_set_radius: 'Click to set radius',
    jgraduate_ellip: 'Ellip:',
    jgraduate_set_ellip: 'Click to set Ellip',
    jgraduate_angle: 'Angle:',
    jgraduate_set_angle: 'Click to set Angle',
    jgraduate_deg: 'deg:',
    jgraduate_opac: 'Opac:',
    jgraduate_set_opac: 'Click to set Opac'
  },
  notification: {
    invalidAttrValGiven: 'Valoarea data nu este validă',
    noContentToFitTo: 'Fara conţinut de referinţă',
    dupeLayerName: 'Deja exista un strat numit asa!',
    enterUniqueLayerName: 'Rog introduceţi un nume unic',
    enterNewLayerName: 'Rog introduceţi un nume pentru strat',
    layerHasThatName: 'Statul deja are acest nume',
    QmoveElemsToLayer: "Mutaţi elementele selectate pe stratul '%s'?",
    QwantToClear: 'Doriti să ştergeţi desenul?\nAceasta va sterge si posibilitatea de anulare!',
    QwantToOpen: 'Doriti sa deschideţi un nou fişier?\nAceasta va şterge istoricul!',
    QerrorsRevertToSource: 'Sunt erori de parsing in sursa SVG.\nRevenire la sursa SVG orginală?',
    QignoreSourceChanges: 'Ignoraţi schimbarile la sursa SVG?',
    featNotSupported: 'Funcţie neimplementată',
    enterNewImgURL: 'Introduceţi noul URL pentru Imagine',
    defsFailOnSave: 'NOTE: Din cauza unei erori in browserul dv., aceasta imagine poate apare gresit (fara gradiente sau elemente). Însă va apare corect dupa salvare.',
    loadingImage: 'Imaginea se incarcă, va rugam asteptaţi...',
    saveFromBrowser: "Select 'Save As...' in your browser (possibly via file menu or right-click context-menu) to save this image as a {{type}} file.",
    noteTheseIssues: 'De asemenea remarcati urmatoarele probleme: ',
    unsavedChanges: 'Sunt schimbări nesalvate.',
    enterNewLinkURL: 'IntroduAliniere în raport cu ...sceţi noul URL',
    errorLoadingSVG: 'Eroare: Nu se pot încărca datele SVG',
    URLLoadFail: 'Nu se poate încărca de la URL',
    retrieving: 'Retrieving \'%s\' ...',
    popupWindowBlocked: 'Popup window may be blocked by browser',
    exportNoBlur: 'Blurred elements will appear as un-blurred',
    exportNoforeignObject: 'foreignObject elements will not appear',
    exportNoDashArray: 'Strokes will appear filled',
    exportNoText: 'Text may not appear as expected',
    editorPreferencesMsg: 'By default and where supported, SVG-Edit can store your editor preferences and SVG content locally on your machine so you do not need to add these back each time you load SVG-Edit. If, for privacy reasons, you do not wish to store this information on your machine, you can change away from the default option below.',
    source_dialog_note: 'Copy the contents of this box into a text editor, then save the file with a .svg extension.'
  }
}
